import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, CredentialsService } from '@auth';
import { ClearPushNotificationSeen } from '@core/utils';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private readonly _authService = inject(AuthenticationService);
  private readonly _router = inject(Router);
  private readonly _credentialsService = inject(CredentialsService);

  ngOnInit() {
    if (!this._credentialsService.isAuthenticated()) {
      this._credentialsService.setCredentials();
      ClearPushNotificationSeen();
      this._router.navigate(['/login']).then(() => {
        window.location.reload();
      });
    } else {
      this._authService.logout().subscribe({
        next: () => {
          this._credentialsService.setCredentials();
          ClearPushNotificationSeen();
          this._router.navigate(['/login']).then(() => {
            window.location.reload();
          });
        },
        error: () => {
          console.error('Error logging out');
          this._credentialsService.setCredentials();
          ClearPushNotificationSeen();
          window.location.href = '/login';
        },
      });
    }
  }
}
